import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, OnChanges, SimpleChanges, AfterContentChecked, Host, Optional, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Participant } from '../models/Participant';
import { MeetingSettings } from '../models/MeetingSettings';
import { MeetingComponent } from '../meeting/meeting.component';
import { SelectMediaComponent } from '../select-media/select-media.component';
import { AudioProcessingService } from '../services/audio-processing.service'
import { MeetingHandlerService } from '../services/meeting-handler.service';

@Component({
  selector: 'app-participant-video-setup-view',
  templateUrl: './participant-video-setup-view.component.html',
  styleUrls: ['./participant-video-setup-view.component.css']
})
export class ParticipantVideoSetupViewComponent implements OnInit, OnDestroy {

  videoEnabled = false;
  audioEnabled = false;
  videoStream: MediaStream;
  audioStream: MediaStream;
  @Input() inMeeting = false;
  //@Input() participant: Participant = new Participant();//username will be empty if not using this component during the meeting
  @ViewChild('video', { static: false }) private video: ElementRef;
  @ViewChild('audio', { static: false }) private audio: ElementRef;
  @ViewChild('volumeMeter') volumeMeter: ElementRef;
  @ViewChild('audioVolume') private audioVolume: ElementRef;
  @Output() videoSettingToggled: EventEmitter<ParticipantVideoSetupViewComponent> = new EventEmitter<ParticipantVideoSetupViewComponent>();
  @Output() audioSettingToggled: EventEmitter<ParticipantVideoSetupViewComponent> = new EventEmitter<ParticipantVideoSetupViewComponent>();
  volumeLevel: number = undefined;

  constructor(@Host() private selectMediaHost: SelectMediaComponent, private audioProcessingService: AudioProcessingService) { }
  ngOnDestroy(): void {
    if(this.videoStream){
      this.videoStream.getVideoTracks().forEach((track) => {
        track.stop();
      });
    }
    if(this.audioStream){
      this.audioStream.getAudioTracks().forEach((track) => {
        track.stop();
      });

      //if(!this.selectMediaHost.inMeeting){
        this.audioProcessingService.endMonitorAudioLevel(MeetingHandlerService.previewAudioLevelId);
      //}
    }
  }
  ngOnInit(): void {
    //debugger;
    this.audioProcessingService.audioLevelReportedSubject.subscribe((params) => {
      const {participantSocketId, volumeLevel} = params;
      //console.log('here 1', volumeLevel);
      if(participantSocketId === MeetingHandlerService.previewAudioLevelId){
        this.audioLevelObserver(volumeLevel);
      }
    })
  }
  
  toggleVideoEnabled(){
    //this.videoEnabled = !this.videoEnabled;
    //this.displayVideo();
    this.videoSettingToggled.emit(this);
  }

  displayVideo(){
    if(this.videoEnabled){
      this.video.nativeElement.srcObject = this.videoStream;
      this.video.nativeElement.muted = true;
    }
    else{
      this.video.nativeElement.srcObject = null;
    }
  }

  toggleAudioEnabled(){
    //this.audioEnabled = !this.audioEnabled;
    //this.displayAudio();
    this.audioSettingToggled.emit(this);
  }

  displayAudio(){
    if(this.audioEnabled){
      this.audio.nativeElement.srcObject = this.audioStream;
    }
    else{
      this.audio.nativeElement.srcObject = null;
    }
  }

  setVideoStream(stream){
    this.videoStream = stream;
    this.displayVideo();
  }

  async setAudioStream(stream){
    this.audioStream = stream;
    this.displayAudio();
    await this.monitorAudioLevel();
  }

  async monitorAudioLevel(){
    if(this.audioStream){
      //using an empty participant id because it's for the current user
      await this.audioProcessingService.monitorAudioLevel(MeetingHandlerService.previewAudioLevelId, this.audioStream);
    }
    else{
      this.audioProcessingService.endMonitorAudioLevel(MeetingHandlerService.previewAudioLevelId);
    }
  }

  audioLevelObserver(volumeLevel: number){
    this.volumeLevel = volumeLevel;
    //[ngStyle]="{width: (this.volumeLevel === undefined || !audioEnabled ? 0 : this.volumeLevel) + '%'}"
    if(this.volumeLevel === undefined || !this.audioEnabled || this.volumeLevel < AudioProcessingService.minimumAudioLevelOfNote){//if it's very low or audio is not enabled, don't show it at all
      this.volumeMeter.nativeElement.style.width = `0px`;
    }
    else{
      this.volumeMeter.nativeElement.style.width = `${this.volumeLevel}%`;
    }
    
    //this.ref.detectChanges();
  }

  muteLocally(muted:boolean){
    this.audio.nativeElement.muted = muted;
  }
}
